import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ChangeDetectorRef
} from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help-accounting-period',
  imports: [CommonModule],
  templateUrl: './help-accounting-period.component.html',
  styleUrl: './help-accounting-period.component.scss'
})
export class HelpAccountingPeriodComponent  {
  selectedSection = 'openaccountingperiod';
  accountingPeriodExpanded = true;
  trialBalanceExpanded = true;
  statementOfFinancialActivitiesExpanded = false;
  receiptsPaymentsExpanded = false;
  balanceSheetExpanded = false;
  statementsOfAssetsLiabilitiesExpanded = false;

  notesExpanded = false;

  trusteesReportExpanded = false;
  trusteeResponsibilityExpanded = false;

  independentExaminerExpanded = false;

  auditorsReportExpanded = false;

  finalAccountsExpanded = false;

  submissionsExpanded = false;

  companiesHouseExpanded = false;


  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.subscribe(section => {

      console.log('Accounting Component received:', section);

      this.selectedSection = section;

      const element = document.getElementById(section);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    });

  }

  toggleAccountingPeriodMenu(): void {
    this.accountingPeriodExpanded = !this.accountingPeriodExpanded;
  }

  toggleTrialBalanceMenu(): void {
    this.trialBalanceExpanded = !this.trialBalanceExpanded;
  }

  toggleStatementOfFinancialActivitiesMenu(): void {
    this.statementOfFinancialActivitiesExpanded =
      !this.statementOfFinancialActivitiesExpanded;
  }

  toggleReceiptsPaymentsMenu(): void {
    this.receiptsPaymentsExpanded =
      !this.receiptsPaymentsExpanded;
  }

  toggleBalanceSheetMenu(): void {
    this.balanceSheetExpanded =
      !this.balanceSheetExpanded;
  }

  toggleStatementsOfAssetsLiabilitiesMenu(): void {
    this.statementsOfAssetsLiabilitiesExpanded =
      !this.statementsOfAssetsLiabilitiesExpanded;
  }

  toggleNotesMenu(): void {
    this.notesExpanded = !this.notesExpanded;
  }

  toggleTrusteesReportMenu(): void {
    this.trusteesReportExpanded =
      !this.trusteesReportExpanded;
  }

  toggleTrusteeResponsibilityMenu(): void {
    this.trusteeResponsibilityExpanded =
      !this.trusteeResponsibilityExpanded;
  }

  toggleIndependentExaminerMenu(): void {
    this.independentExaminerExpanded =
      !this.independentExaminerExpanded;
  }

  toggleAuditorsReportMenu(): void {
    this.auditorsReportExpanded =
      !this.auditorsReportExpanded;
  }

  toggleFinalAccountsMenu(): void {
    this.finalAccountsExpanded =
      !this.finalAccountsExpanded;
  }

  toggleSubmissionsMenu(): void {
    this.submissionsExpanded =
      !this.submissionsExpanded;
  }

  toggleCompaniesHouseMenu(): void {
    this.companiesHouseExpanded =
      !this.companiesHouseExpanded;
  }

  changeSection(section: string): void {

    console.log('Clicked:', section);

    const element = document.getElementById(section);

    console.log('Element found:', element);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    this.selectedSection = section;
    this.navigationService.selectedSection.next(section);
  }
}
